<template>
  <validation-provider
    v-slot="{ errors, failed }"
    :name="item.name"
    :rules="validationRules"
  >
    <div :class="{'validation-failed':failed}">
      <item-name :item="item" />
      <div class="flex flex-col">
        <template v-for="option in options">
          <label
            v-if="option.show"
            :key="option.id"
            :for="`option-${option.id}`"
            class="flex items-center mb-4 border-3 p-4 bg-gray-800 border-transparent cursor-pointer focus-within:border-orange-700 hover:border-orange-700"
            :class="{'gradient border-white': option.id === value}"
          >
            <input
              :id="`option-${option.id}`"
              v-model="value"
              type="radio"
              :value="option.id"
              :name="itemName"
              class="sr-only"
            >
            <span>{{ option.name }}</span>
          </label>
        </template>

        <div v-if="item.meta.allowOtherChoice">
          <label
            :for="otherOptionName"
            class="flex items-center mb-4 border-3 p-4 bg-gray-800 border-transparent cursor-pointer focus-within:border-orange-700 hover:border-white"
            :class="{'gradient border-white': otherOptionName === value}"
          >
            <input
              :id="otherOptionName"
              v-model="value"
              type="radio"
              :value="otherOptionName"
              :name="itemName"
              class="sr-only"
              @change="selectOtherOption"
            >
            <span>{{ otherLabel }}</span>
          </label>

          <div
            v-if="showOtherInput"
          >
            <validation-provider
              v-slot="{ errors, failed }"
              :name="otherLabel"
              :rules="validationRules"
            >
              <div class="font-bold font-display mb-2">
                {{ otherLabel }}
              </div>
              <input
                ref="otherInput"
                v-model="otherValue"
                type="text"
                class="px-4 py-4 bg-gray-800 text-gray-100 w-full border-3 border-transparent outline-none focus:border-orange-700"
              >
              <item-errors :errors="errors" />
            </validation-provider>
          </div>
        </div>
      </div>
      <item-errors :errors="errors" />
    </div>
  </validation-provider>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'
import ItemErrors from './item-errors'

export default {
  components: {
    ItemName,
    ItemErrors
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    options () {
      let options = this.item.meta.options
      return options.sort((a, b) => a.order - b.order)
    },
    otherOptionName () {
      return `option-${this.item.id}-other`
    },
    otherLabel () {
      return this.item.meta.otherChoiceLabel ? this.item.meta.otherChoiceLabel : 'Other'
    },
    showOtherInput () {
      if (this.item.value === this.otherOptionName) {
        return true
      }

      if (this.item.otherValue) {
        return true
      }

      return (this.item.value === this.otherOptionName)
    },
    hasOtherValue () {
      let hasItem = this.item.meta.options.findIndex(option => option.id === this.item.value)

      if (hasItem === -1) {
        return !!this.item.otherValue
      }

      return false
    },
    otherValue: {
      get () {
        return this.item.otherValue
      },
      set (value) {
        let item = { ...this.item }
        item.otherValue = value
        this.$store.commit('survey/ITEM_UPDATED', item)
      }
    }
  },
  mounted () {
    if (this.hasOtherValue) {
      this.value = this.otherOptionName
    }
  },
  created () {
    if (!this.item.hasOwnProperty('otherValue')) {
      this.item.otherValue = null
    }
  },
  methods: {
    selectOtherOption () {
      this.$nextTick(() => {
        this.$refs.otherInput.focus()
      })
    }
  }
}
</script>
